
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/merch",
      function () {
        return require("private-next-pages/[athleteSlug]/merch.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/merch"])
      });
    }
  